import React, { useMemo } from 'react';
import { DisclaimerInfo } from 'QuoteApp/components/DisclaimerInfo';
import {
  useAppContext,
  useAppAvailableProducts,
} from 'QuoteApp/services/providers';
import { renderOperatingCompany } from 'Shared/utils/formatters';

export const PurchaseDisclaimer = () => {
  const { details } = useAppContext();
  const availableProducts = useAppAvailableProducts();
  const { productSegment } = details || {};

  const disclaimer = useMemo(() => {
    const availableProduct = availableProducts?.find(
      product => product.productSegment === productSegment
    );

    if (!availableProduct) return null;

    return `This policy will be underwritten by ${renderOperatingCompany(
      availableProduct
    )}.`;
  }, [productSegment, availableProducts]);

  return disclaimer ? <DisclaimerInfo text={disclaimer} /> : null;
};
